import React from 'react'

import Base from '../_Base'

const Brazil12 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_12)">
      <rect width="24" height="24" rx="2" fill="#FBC115" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.796 9.613v.148c0 .465-.068.901-.204 1.304-.136.402-.368.833-.692 1.298l-2.273 3.225h3.34v1.531h-5.403v-1.876l2.352-3.43c.272-.391.482-.76.624-1.111.142-.352.215-.663.215-.936v-.408c0-.504-.034-.839-.107-.997-.074-.165-.204-.244-.397-.244-.182 0-.306.085-.38.255-.074.17-.108.499-.108.986v.408h-2.04v-.153c0-1.031.186-1.746.555-2.137.374-.397 1.037-.595 1.99-.595.952 0 1.61.193 1.978.584.363.397.55 1.111.55 2.148ZM8.48 7.045h1.706V17.12h-1.95V9.63c-.17.176-.352.323-.55.454a3.316 3.316 0 0 1-.652.317V8.593c.346-.199.646-.425.884-.686.25-.26.437-.544.561-.862Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_12">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default Brazil12
